/* Use Beyond's original Cart and Drawer in the storefront window. */
(() => {
  const nativeTheme = import(document.currentScript.dataset.themeModule);
  nativeTheme.catch(() => {});
  const trigger = () => document.activeElement instanceof HTMLElement
    ? document.activeElement : document.getElementById('a11y_skip');
  window.addEventListener('theme:cart:updated', () => {
    window.dispatchEvent(new Event('photo-story:cart-updated'));
  });
  window.photoStoryCart = {
    async open() {
      const { Cart, Drawer } = await nativeTheme;
      const response = await fetch(`${Shopify.routes.cart_update}.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ sections: Cart.sections })
      });
      if (!response.ok) throw new Error('Could not load your cart. Please try again.');
      const cart = await response.json();
      Cart.fillBasket(cart.items);
      Cart.updateTotals(cart.item_count);
      Cart.updateAllHtml(cart.sections, true);
      Drawer.open('right', 'cart-drawer', trigger());
    },
    async add(item, submitter) {
      const { Cart } = await nativeTheme;
      await Cart.fetchBasket();
      await Cart.addItems({
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item], sections: Cart.sections })
      }, submitter instanceof HTMLElement ? submitter : trigger());
    }
  };
})();
